import styled from "styled-components"
import { 
    // COLOR,
    // FONT
 } from 'assets'
 
export const PaymentProcessContainerStyled = styled.div`
/*===============================================
 Container 
===============================================*/
    
/*===============================================
Theme 
===============================================*/
    
`